import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Sidebar from '../news-components/sidebar';
import Loader from '../global-components/loader';

const CatSports = () => {

	const { catId } = useParams();
	const [news, setnews] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const newsPerPage = 15; // Number of news per page
	useEffect(() => {
		setCurrentPage(1);
		window.scrollTo(0, 0);
		const cacheBuster = new Date().getTime(); // Generates a unique timestamp
		const fetchnews = async () => {
			try {
				const response = await fetch(`https://khapa.tagit.pk/api/blog.php?news=cat_wise_news&cat_id=${catId}&_=${cacheBuster}`);
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				const data = await response.json();
				setnews(data);
			} catch (error) {
				setError(error.message);
			} finally {
				setLoading(false);
			}
		};

		fetchnews();
	}, [catId]);

	let publicUrl = process.env.PUBLIC_URL + '/';
	const formatDate = (dateString) => {
		if (!dateString) return 'N/A';
		const date = new Date(dateString);
		return date.toLocaleDateString('en-US', {
		  year: 'numeric',
		  month: 'long',
		  day: 'numeric'
		});
	  };

	// Helper function to truncate content to 100 words
	const truncateContent = (content) => {
		return content.split(' ').slice(0, 100).join(' ') + '...';
	};

	// Pagination calculations
	const indexOfLastnews = currentPage * newsPerPage;
	const indexOfFirstnews = indexOfLastnews - newsPerPage;
	const currentnews = news.slice(indexOfFirstnews, indexOfLastnews);
	const totalPages = Math.ceil(news.length / newsPerPage);

	// Pagination calculations
	const maxVisibleLinks = 10; // Maximum number of visible page links
	const halfMaxLinks = Math.floor(maxVisibleLinks / 2);

	const generatePagination = () => {
		let pagination = [];
		const startPage = Math.max(1, currentPage - halfMaxLinks);
		const endPage = Math.min(startPage + maxVisibleLinks - 1, totalPages);

		// Add the first page and ellipsis if necessary
		if (startPage > 1) {
			pagination.push(1);
			if (startPage > 2) pagination.push("...");
		}

		// Add the visible range of page numbers
		for (let i = startPage; i <= endPage; i++) {
			pagination.push(i);
		}

		// Add ellipsis and the last page if necessary
		if (endPage < totalPages) {
			if (endPage < totalPages - 1) pagination.push("...");
			pagination.push(totalPages);
		}

		return pagination;
	};

	const pagination = generatePagination();


	const handlePageChange = (pageNumber) => {
		setCurrentPage(pageNumber);
		window.scrollTo({
			top: 0,
			behavior: 'smooth', // Optional for a smooth scroll effect
		});
	};

	if (loading) {
        return <Loader />;
    }


	if (error) {
		return <p>Error: {error}</p>;
	}

	return <div className="cat-page-area pd-bottom-80 go-top">
		<div className="container">
			<div className="row">
				<div className="col-lg-9 pd-top-50">
					{news.length === 0 ? (
						<div className="no-news-found">
							<h3>No News Found</h3>
							<p>Please check back later for updates in this category.</p>
						</div>
					) : (
						<div className="row">
							{currentnews.map((news) => (
								<div key={news.id} className="col-lg-4 col-md-6">
									<div className="single-post-wrap style-box">
										<div className="thumb">
											<img 
											src={news.post_image ? news.post_image : `${publicUrl}assets/img/tech/1.png`} 
											alt={news.title || news.category+" news image"} 
											onError={(e) => {
												e.target.onerror = null; // Prevents infinite loop in case default image fails
												e.target.src = `${publicUrl}assets/img/tech/1.png`; // Set default image
											  }}
											/>
										</div>
										<div className="details">
											<div className="post-meta-single mb-4 pt-1">
												<ul>
													<li><Link className="tag-base tag-light-blue" to={{ pathname: `/news-details/${news.id}`, state: { news } }}>{formatDate(news.updated_at || news.created_at)}</Link></li>
													<li><i className="fa fa-user" />{news.author}</li>
												</ul>
											</div>
											<h6 className="title"><Link to={{ pathname: `/news-details/${news.id}`, state: { news } }}>{news.title}</Link></h6>
											<Link className="btn btn-base mt-4" to={{ pathname: `/news-details/${news.id}`, state: { news } }}>Read more</Link>
										</div>
									</div>
								</div>
							))}
						</div>
					)}
					{/* Pagination */}
					{news.length > 0 && (
						<nav className="mt-4">
							<ul className="pagination">
								<li className={`page-item prev ${currentPage === 1 ? 'disabled' : ''}`}>
									<button
										className="page-link"
										onClick={() => handlePageChange(currentPage - 1)}
										disabled={currentPage === 1}
									>
										<i className="fa fa-angle-left" />
									</button>
								</li>
								{pagination.map((item, index) => (
									<li
										key={index}
										className={`page-item ${item === currentPage ? 'active' : ''} ${item === "..." ? "disabled" : ""
											}`}
									>
										{item === "..." ? (
											<span className="page-link">{item}</span>
										) : (
											<button className="page-link" onClick={() => handlePageChange(item)}>
												{item}
											</button>
										)}
									</li>
								))}
								<li className={`page-item next ${currentPage === totalPages ? 'disabled' : ''}`}>
									<button
										className="page-link"
										onClick={() => handlePageChange(currentPage + 1)}
										disabled={currentPage === totalPages}
									>
										<i className="fa fa-angle-right" />
									</button>
								</li>
							</ul>
						</nav>
					)}
				</div>
				<Sidebar />
			</div>
		</div>
	</div>
}

export default CatSports